export enum XpoAgGridBoardApiAction {
  FocusRow = 'focusRow',
  UpdateEditingState = 'updateEditingState',
}
